import React from 'react';
import { Seo, breadcrumbSchema, webPageSchema } from '../components/Seo';
import PageHeader from '../components/PageHeader';
import Reveal from '../components/Reveal';
import { JUDGING_CRITERIA } from '../data/content';

const Judging = () => (
  <div data-testid="page-judging">
    <Seo
      title="Judging Process · AdAura Awards 2026 Marketing Awards India"
      description="How the AdAura Awards jury evaluates India's finest marketing work. Blind judging across strategy, creativity, execution, and measurable business impact by senior CMOs and industry leaders."
      path="/judging"
      jsonLd={[
        webPageSchema({ path: '/judging', name: 'Judging', description: "How the AdAura Awards jury evaluates India's finest marketing work. Blind judging across strategy, creativity," }),
        breadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Judging', path: '/judging' }]),
      ]}
    />
    <PageHeader
      title="Judging Criteria"
      italicWords={['Criteria']}
    />

    {/* INTRO */}
    <section className="pb-12">
      <div className="content-container">
        <Reveal>
          <p className="font-serif italic text-white/85 text-xl md:text-2xl max-w-4xl leading-tight">
            A six-point framework designed to recognise
            <span className="text-[#C9A56C]"> the work that delivers meaningful results.</span>
          </p>
        </Reveal>
      </div>
    </section>

    {/* 2x3 GRID */}
    <section className="section-pad pt-8 bg-[#634F3A]">
      <div className="content-container">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#C9A56C]/20" data-testid="criteria-grid">
          {JUDGING_CRITERIA.map((c, i) => (
            <Reveal key={c.roman} delay={i * 90} className="bg-[#5A4733] p-8 md:p-10 border border-[#C9A56C]/0 min-h-[260px] flex flex-col">
              <span className="numeral text-5xl md:text-6xl">{c.roman}</span>
              <h3 className="font-serif text-white text-2xl md:text-3xl mt-10 leading-tight">{c.name}</h3>
              <p className="text-white/60 text-sm md:text-base mt-4 leading-relaxed">{c.desc}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>

  </div>
);

export default Judging;
